<template>
  <div class='sub-page' style='margin:0 auto;'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='company-grid'>
        <dx-data-grid ref='refCompanyGrid'
          :data-source='companyInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          @selection-changed = "onSelectionChanged"
          @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating='onUpdating'
          @editor-preparing='onEditorPreparing'
          @init-new-row='onInitNewRow'
          @rowDblClick ='onRowDbClick'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="거래처정보"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="true"
            :allow-updating="true"
            :allow-adding="true"
            :use-icons="true"
            mode='popup'
          >
            <DxPopup
              :show-title="true"
              :width="700"
              :height="450"
              title="거래처관리"
            >
              <dx-position
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="90"
            :buttons="editButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="거래처코드"
            data-field="거래처코드"
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            sort-order='asc'
            caption="거래처명"
            data-field="거래처명"
            >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="본사명"
            data-field="본사코드"
          >
            <DxLookup
              :data-source="customerGroupLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="구분"
            data-field="거래처구분코드"
            :visible='true'
            >
            <DxLookup
              :data-source="partnerLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="회사연락처"
            data-field="회사연락처"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="팩스번호"
            data-field="팩스번호"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="대표이사"
            data-field="대표이사명"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사업자번호"
            data-field="사업자번호"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="주소"
            data-field="주소"
            :visible='true'
            width="200"
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="담당자"
            data-field="담당자"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="담당연락처"
            data-field="담당자연락처"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="이메일"
            data-field="이메일"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="아이디"
            data-field="아이디"
            :visible='true'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="비번"
            data-field="암호"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사용유무"
            data-field="사용유무"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible='true'
            caption="수정일"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
          >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="거래처코드"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: '거래처관리'
        }
      ],
      editButtons: ['edit', 'delete',
        {
          hint: '암호초기화',
          icon: 'refresh',
          visible: 'true',
          onClick: this.onClickPasswdRefresh
        }],
      companyInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: null,
      partnerLookup: null,
      customerGroupLookup: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxTabPanel,
    DxScrolling
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.partnerLookup = ConstDef.COMPANY_TYPE
    this.customerGroupLookup = this.$store.getters.getBaseDataByType(ConstDef.고객사그룹)
    console.log(this.customerGroupLookup)
    this.refreshCompany()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onClickPasswdRefresh (e) {
      // console.log(e)
      this.$snotify.confirm('123456789로 암호를 초기화 합니다. 초기화하시겠습니까?', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '초기화',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.initPasswd(e.row.data)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    initPasswd (row) {
      let param = {
        암호: '123456789',
        거래처코드: row.거래처코드
      }
      this.$_sp.runUpdateSqlProc('거래처정보', ['거래처코드'], null, [param])
        .then((data) => {
          this.$snotify.info('변경 되었습니다.')
        })
        .catch(error => {
          // console.log(error)
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onEditorPreparing (e) {
      if (e.dataField === '거래처코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
        console.log(this.isIdEdit)
      }
    },
    onInitNewRow (row) {
      console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.거래처코드 = '자동생성'
    },
    onRowDbClick (row) {
      this.$refs.refCompanyGrid.instance.editRow(row.rowIndex)
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userId
      this.$_sp.runInsertAndUpdateIdSqlProc('거래처정보', ['거래처코드'], ['seqId'], 'seqId', '거래처코드', 'A', AppLib.deleteUnderlineKey(row.data))
        .then((data) => {
          let newData = this.$_sp.MakeModel(data)[0]
          row.data.seqId = newData.seqId
          row.data.거래처코드 = newData.거래처코드
          this.$refs.refCompanyGrid.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onRowInserting (row) {
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('거래처정보', [{ 거래처코드: row.data.거래처코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('거래처정보', ['거래처코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onSelectionChanged (row) {
      if (row.selectedRowsData.length === 0) {
        return
      }
      this.selectedRow = row.selectedRowsData[0]
    },
    refreshCompany () {
      this.isLoading = true

      this.$_sp.runNoEncodeFindSqlProc('거래처정보', null)
        .then((data) => {
          this.companyInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
          console.log(this.companyInfoList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }

  }
}
</script>

<style lang="scss">
.ff{
  text-align: center;
}
</style>
